module.exports = __webpack_public_path__ + "img/brands-tec.30d68ca6.svg";